/**
 * Common analytics events for the application
 * This file contains constants for event names and parameter keys
 * to ensure consistency across the application
 */

// Event Names
export const ANALYTICS_EVENTS = {
  // Page Views
  PAGE_VIEW: 'page_view',
  
  // User Actions
  BUTTON_CLICK: 'button_click',
  LINK_CLICK: 'link_click',
  FORM_SUBMIT: 'form_submit',
  FORM_ERROR: 'form_error',
  
  // Contact Events
  CONTACT_FORM_SUBMIT: 'contact_form_submit',
  WHATSAPP_CHAT_CLICK: 'whatsapp_chat_click',
  
  // Content Engagement
  CONTENT_VIEW: 'content_view',
  CONTENT_SHARE: 'content_share',
  
  // Ecommerce Events
  VIEW_ITEM: 'view_item',
  ADD_TO_CART: 'add_to_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  
  // Custom Events
  PLAN_SELECTED: 'plan_selected',
  FEATURE_USED: 'feature_used',
  SEARCH: 'search',
};

// Parameter Keys
export const ANALYTICS_PARAMS = {
  // General
  SOURCE: 'source',
  MEDIUM: 'medium',
  CAMPAIGN: 'campaign',
  
  // Content
  CONTENT_TYPE: 'content_type',
  CONTENT_ID: 'content_id',
  CONTENT_NAME: 'content_name',
  
  // User
  USER_TYPE: 'user_type',
  
  // Forms
  FORM_TYPE: 'form_type',
  FORM_NAME: 'form_name',
  FORM_STEP: 'form_step',
  
  // Ecommerce
  ITEM_ID: 'item_id',
  ITEM_NAME: 'item_name',
  ITEM_CATEGORY: 'item_category',
  PRICE: 'price',
  CURRENCY: 'currency',
  
  // Custom
  PLAN_TYPE: 'plan_type',
  FEATURE_NAME: 'feature_name',
  SEARCH_TERM: 'search_term',
};
